import { useState, useEffect, useRef } from 'react'


const FrontPageNoisemeterV2 = ({ isActiveWomensMode }) => {
    const [status, setStatus] = useState(() => sessionStorage.getItem('noisev2.mic_granted') === 'true' ? 'success' : 'idle');
    const wakeLockRef = useRef(null);

    // Configuración optimizada para iPhone/Móviles
    const audioConstraints = {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: false
    };

    const requestWakeLock = async () => {
        try {
            if ('wakeLock' in navigator) {
                if (window.activeWakeLock) return; // Ya hay un bloqueo activo
                
                const lock = await navigator.wakeLock.request('screen');
                wakeLockRef.current = lock;
                window.activeWakeLock = lock;
                console.log("[WakeLock V2] 🔓 Bloqueo de pantalla activado en bienvenida.");
            }
        } catch (err) {
            console.warn("[WakeLock V2] Error al solicitar WakeLock:", err);
        }
    };

    useEffect(() => {
        // Intentar auto-detectar si ya se concedió el permiso de micrófono nativamente
        if (navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({ name: 'microphone' })
                .then((permissionStatus) => {
                    if (permissionStatus.state === 'granted') {
                        setStatus('success');
                        sessionStorage.setItem('noisev2.mic_granted', 'true');
                        requestWakeLock();
                    }
                    
                    permissionStatus.onchange = () => {
                        if (permissionStatus.state === 'granted') {
                            setStatus('success');
                            sessionStorage.setItem('noisev2.mic_granted', 'true');
                        } else if (permissionStatus.state === 'denied') {
                            setStatus('error');
                            sessionStorage.removeItem('noisev2.mic_granted');
                        } else {
                            setStatus('idle');
                            sessionStorage.removeItem('noisev2.mic_granted');
                        }
                    };
                })
                .catch(err => {
                    console.warn("[Mic V2] Error consultando permisos de micrófono:", err);
                });
        }
    }, []);

    const handlePreActivate = async () => {
        try {
            // 1. Intentamos bloquear la pantalla para mantenerla activa
            await requestWakeLock();

            // 2. Solicitamos el micrófono con las constraints de iPhone
            const stream = await navigator.mediaDevices.getUserMedia({ audio: audioConstraints });
            
            // 3. Éxito: marcamos estado y persistimos en la sesión
            setStatus('success');
            sessionStorage.setItem('noisev2.mic_granted', 'true');
            
            // 4. Liberamos el stream inmediatamente para no gastar batería/recursos
            stream.getTracks().forEach(track => track.stop());

        } catch (error) {
            console.error("Permiso denegado o error de hardware V2", error);
            setStatus('error');
            sessionStorage.removeItem('noisev2.mic_granted');
        }
    };

    return (
        <div className={`FrontPageNoisemeter__Fan ${isActiveWomensMode ? 'FrontPageNoisemeter__Fan--Female' : 'FrontPageNoisemeter__Fan--Male'}`}>
            <div className="FrontPageNoisemeter__Fan__Card">
                
                <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Medium FrontPageNoisemeter__Fan__Element--SpaceUp">Ruidómetro</p>
                
                {/* ESTADO INICIAL */}
                {status === 'idle' && (
                    <>
                        <p className="FrontPageNoisemeter__Fan__Text--Center"><span className='FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Text--Highlight'>Activa tu micrófono ahora</span> para estar listo cuando inicie el juego.</p>
                        
                        <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
                            <i className="bi bi-mic-fill"></i> Activar micrófono ahora
                        </button>

                        <p className="FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--SpaceUp">Para participar, necesitamos medir tus gritos y mantener tu pantalla encendida.</p>
                    </>
                )}

                {/* ESTADO ÉXITO */}
                {status === 'success' && (
                    <div className="">
                        <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
                            <i className="bi bi-check-circle-fill"></i>
                        </p>
                        <p className='FrontPageNoisemeter__Fan__Text--Success FrontPageNoisemeter__Fan__Text--Center'>¡Estás listo!</p>
                        <p className="FrontPageNoisemeter__Fan__Text--Center">Esperando a que inicie la dinámica...</p>
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>No cierres esta pantalla</p>
                    </div>
                )}

                {/* ESTADO ERROR (Permiso denegado) */}
                {status === 'error' && (
                    <div className="FrontPageNoisemeter__Fan__Error">
                        <p className='FrontPageNoisemeter__Fan__Text--Danger FrontPageNoisemeter__Fan__Text--Big FrontPageNoisemeter__Fan__Text--Center FrontPageNoisemeter__Fan__Element--ZeroBottom'>
                            <i className="bi bi-mic-mute-fill"></i>
                        </p>
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>Permiso denegado</p>
                        
                        <p className='FrontPageNoisemeter__Fan__Text--Center'>
                            <span className='FrontPageNoisemeter__Fan__Text--Highlight'>Necesitamos acceso a tu micrófono</span> para jugar.
                        </p>
                        
                        <button className="FrontPageNoisemeter__Fan__Element--Center FrontPageNoisemeter__Fan__Button Btn__Adsl--Red" onClick={handlePreActivate}>
                            <i className="bi bi-arrow-clockwise"></i> Intentar activar de nuevo
                        </button>

                        <p className='FrontPageNoisemeter__Fan__Text--Center' style={{fontSize: '0.8rem', marginTop: '10px', opacity: 0.8}}>
                            Si no aparece el mensaje, toca el ícono de 🔒 o configuración en tu navegador y permite el micrófono.
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
};

export { FrontPageNoisemeterV2 };
